import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Constants } from '../models/constants';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    public static readonly SNACK_BAR_ACTION_CLOSE = 'Close';
    public static readonly SNACK_BAR_DURATION = 5000;
    public static readonly SNACK_BAR_DURATION_LONG = SnackbarService.SNACK_BAR_DURATION * 2;

    public static readonly SNACK_BAR_CLASS_ALERT = 'alert';
    public static readonly SNACK_BAR_CLASS_SUCCESS = 'success';
    public static readonly SNACK_BAR_CLASS_PROCESSING = 'processing';
    constructor(private readonly snackBar: MatSnackBar, private readonly zone: NgZone) {}

    openSnackBar(message: string, snackBarClass: string, duration: number = SnackbarService.SNACK_BAR_DURATION) {
        this.zone.run(() => {
            this.snackBar.open(message, SnackbarService.SNACK_BAR_ACTION_CLOSE, {
                duration,
                panelClass: [snackBarClass]
            });
        });

        return this.snackBar._openedSnackBarRef.afterDismissed();
    }

    openSnackBarNoAutoDismiss(message: string, snackBarClass: string) {
        this.zone.run(() => {
            this.snackBar.open(message, SnackbarService.SNACK_BAR_ACTION_CLOSE, {
                panelClass: [snackBarClass]
            });
        });

        return this.snackBar._openedSnackBarRef.afterDismissed();
    }
}
